export default "__VITE_ASSET__CdgYuGyu__"